// use-agents.ts
import { useQuery } from "@tanstack/react-query";
import http from "../../utils/http-common";

export interface Agent {
  id: number;
  name: string;
  status: string;
  state: boolean;
}

export function useAgents() {
  const fetchAgents = async (): Promise<Agent[]> => {
    const response = await http.get<Agent[]>("/agent");
    return response.data;
  };

  return useQuery<Agent[]>({
    queryKey: ["agents"],
    queryFn: fetchAgents,
    // staleTime: 1000 * 60 * 5,
  });
}
